import API from './request';

/**
 * 出口合规（Export Compliance）接口
 *
 * 说明：本轮只实现审查单「创建」，不做结果轮询（query-result）与回调（callback）。
 * 预检接口（market-activity / customer / feedback）沿用各业务模块既有的 service 方法，地址不变。
 */
export const ExportComplianceServer = {
    // 创建审查单：engineLogId 与 detectionId 二选一，优先 engineLogId
    reviewCreate: (params) => API.post('compliance-verification/review/create', params)
};
